export const defaultValuesAddressPicker = {
  Fernwaerme: '',
  Gas: '',
  Internet: '',
  Iptv: '',
  Strom: '',
  Voip: '',
  currentAddress: '',
  gebadr1: '',
  gemeinde: '',
  olavKeys: {},
  plzOrt: '',
  stiege: '',
  strasse: '',
  tuerNr: '',
  tkconnid: '',
};

export const fieldDependencies = {
  plzOrt: [],
  gemeinde: ['plzOrt'],
  strasse: ['gemeinde', 'plzOrt'],
  gebadr1: ['plzOrt', 'strasse'],
  stiege: ['plzOrt', 'strasse', 'gebadr1'],
  tuerNr: ['plzOrt', 'strasse', 'gebadr1'],
};

export const prepareRequeryWithoutStiege = formData => {
  const { gebadr1, hausnummer, plz, gemeinde, strasse } = formData;
  const [hausNr, stiege] = (gebadr1 || hausnummer).split('/') || [];

  if (!stiege) return null;

  return {
    field: 'gebadr1',
    search: hausNr || '',
    plzOrt: plz || '',
    gemeinde: gemeinde || '',
    strasse: strasse || '',
    stiege: '',
  };
};

// Helper function to check if heat data is unavailable
export const checkIfHeatDataUnavailable = heatResponse => {
  return (
    heatResponse?.olavGaa &&
    !(
      heatResponse?.fernwaermeVerfuegbar ||
      heatResponse?.fernwaermePioniergebiet ||
      heatResponse?.fernwaermeZukunft ||
      heatResponse?.fernwaermeHeute ||
      heatResponse?.lokaleWaermeIndividuell ||
      heatResponse?.lokaleWaermeGemeinsam ||
      heatResponse?.aktivesAusbaugebiet
    )
  );
};

// Function to check if request parameters have changed
export const haveParamsChanged = (newParams, lastParams) => {
  return newParams.olavGaa !== lastParams?.olavGaa;
};

export const getFernwaermeCase = heatResponse => {
  const {
    olavGaa,
    fernwaermeVerfuegbar,
    fernwaermePioniergebiet,
    fernwaermeZukunft,
    fernwaermeHeute,
    lokaleWaermeIndividuell,
    lokaleWaermeGemeinsam,
    aktivesAusbaugebiet,
  } = heatResponse;

  // Case: Missing OlavKey or only OlavKey is returned
  if (!olavGaa) return 'heatError';

  if (heatResponse.length === 1) {
    return 'dataIssue';
  }

  // Case: OlavKey is available but all other properties return "nein"
  if (
    olavGaa &&
    [
      fernwaermePioniergebiet,
      fernwaermeHeute,
      fernwaermeZukunft,
      fernwaermeVerfuegbar,
      lokaleWaermeIndividuell,
      lokaleWaermeGemeinsam,
      aktivesAusbaugebiet,
    ].every(value => value === 'nein')
  ) {
    return 'dataIssue';
  }

  // Case: fernwaermeVerfuegbar returns "ja"
  if (fernwaermeVerfuegbar === 'ja') return 'webGISVerfuegbar';

  // Case: fernwaermeVerfuegbar returns "nein", Pioniergebiet returns not "nein"
  if (fernwaermePioniergebiet !== 'nein')
    return fernwaermePioniergebiet?.toLowerCase();

  // Case: fernwaermeVerfuegbar and Pioniergebiet return "nein" and aktivesAusbaugebiet returns "ja"
  if (aktivesAusbaugebiet === 'ja') return 'aktivesAusbaugebiet';

  // Case: fernwaermeVerfuegbar, Pioniergebiet and aktivesAusbaugebiet return "nein" and fernwaermeHeute returns "ja"
  if (fernwaermeHeute === 'ja') return 'fernwaermeHeute';

  // Case: fernwaermeVerfuegbar, Pioniergebiet, aktivesAusbaugebiet, and fernwaermeHeute return "nein", and fernwaermeZukunft returns "ja"
  if (fernwaermeZukunft === 'ja') return 'fernwaermeZukunft';

  // Case: fernwaermeVerfuegbar, Pioniergebiet, aktivesAusbaugebiet, fernwaermeHeute and fernwaermeZukunft return "nein", and lokaleWaermeGemeinsam returns "ja"
  if (lokaleWaermeGemeinsam === 'ja') return 'lokaleWaermeGemeinsam';

  // Case: All others return "nein", and lokaleWaermeIndividuell returns "ja"
  if (lokaleWaermeIndividuell === 'ja') return 'lokaleWaermeIndividuell';

  // Default fallback if none of the conditions are met
  return 'heatError';
};
